import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('banner-message', () => import(/* webpackMode: "lazy" */'./banner-message'));
